export default function Change(submissionId) {
  this.submissionID = submissionId
  this.changeID = null
  this.changeTypeID = 0
  this.narrative = ''
  this.effectiveDate = ''
  this.reportedDate = ''
  this.isSpousalRelationship = ''
  this.spousalRelationshipReason = ''
  this.anyHadAnotherName = ''
  this.areCurrentlyRelated = ''
  this.werePreviouslyRelated = ''
  this.wereAssetsAcquired = ''
  this.wasMajorityOwnerIdentifiedWithFormer = ''
  this.relatedNameOfBusiness = ''
  this.relatedPrincipalLocation = ''
  this.relatedCarrierPolicyNumber = ''
  this.relatedEffectiveDate = ''
  this.acquiredNameOfEntity = ''
  this.acquiredOwnership = ''
}